<template>
  <div id="pie1" style="width: 100%; height: 100%"></div>
</template>

<script>
export default {
  name: "ChartPie",
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.chart = this.$echarts.init(document.getElementById("pie1"));
    window.addEventListener("resize", () => {
      if (this.chart) {
        this.chart.resize();
      }
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart(data) {
      let datas = [];
      if (data && data.length > 0) {
        data.forEach((item) => {
          datas.push({
            value: item.num,
            name: item.terminal === 1 ? "管理端" : "移动端",
          });
        });
      }
      const option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "center",
          left: "right",
        },
        series: [
          {
            name: "设备信息",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            padAngle: 5,
            itemStyle: {
              borderRadius: 10,
            },
            label: {
              show: true,
              normal: {
                show: true,
                formatter: "{b} : {c} ({d}%)",
                textStyle: {
                  color: "#1f2329",
                },
              },
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: true,
            },
            color: ["#5470c6", "#91cc75", "#ee6666", "#d48265", "#91c7ae"],
            data: datas,
          },
        ],
      };
      this.chart.setOption(option);
    },
  },
};
</script>
